<div (click)="onClick()" [class.titulo-sort-ordenable]="ordenable">
  <ng-content></ng-content>
  <i class="bi bi-sort-down-alt" *ngIf="orderColumn==campo && orderDirection=='asc'"></i>
  <i class="bi bi-sort-up-alt" *ngIf="orderColumn==campo && orderDirection=='desc'"></i>
</div>
